import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { config } from 'utils/config';
import {
  StyledContainer,
  StyledCta,
  StyledFooter
} from './JuniorsFooter.styled';

const JuniorsFooter: React.FC = () => {
  const { t } = useI18n('helping-juniors');
  const { locale } = useRouter();

  return (
    <StyledFooter>
      <StyledContainer>
        <Heading2 editorial alignLeft>
          {t('helping-juniors.footer.title')}
        </Heading2>
        <p>
          <Trans
            ns={'helping-juniors'}
            i18nKey={'helping-juniors.footer.desc'}
            components={{
              mailToSupportLink: <a href={`mailto:${config.supportEmail}`} />
            }}
          ></Trans>
        </p>
        <StyledCta>
          <p>{t('helping-juniors.footer.cta-title')}</p>
          <ButtonLink
            href={`${getAppUrl(
              APP_URLS.join,
              locale
            )}?locale=${locale}&source=footer-helping-juniors`}
            variant="brandTalent"
            onClick={(e) =>
              ServiceEventTracking.trackExternalLandingCtaClicked(
                e,
                `${getAppUrl(
                  APP_URLS.join,
                  locale
                )}?locale=${locale}&source=footer-helping-juniors`,
                'footer-helping-juniors'
              )
            }
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('helping-juniors.footer.cta')}</span>
          </ButtonLink>
        </StyledCta>
      </StyledContainer>
    </StyledFooter>
  );
};

export default JuniorsFooter;
